import React from "react";
import Integrations from "../../components/integrations/Integrations";

function IntegrationsPage() {
  return <Integrations />;
}

export default IntegrationsPage;
